// THIS FILE IS AUTOMATICALLY GENERATED. DO NOT MODIFY IT MANUALLY.

import { THEME_NAME, THEME_MODE } from '../../../symbol';
/**
 * Design System theme object.
 *
 * Theme name: `trellis`
 *
 * Theme mode: `light`
 */
const theme = {
  borderRadius: {
    '0': '0px',
    '100': '4px',
    '200': '4px',
    '300': '8px',
    '400': '16px',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-core-component-default': '999999px',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-textarea-default': '16px',
    full: '999999px',
    'fwc-alert': '4px',
    'fwc-button': '4px',
    'fwc-dropdown-options-container': '8px',
    'fwc-expandabletext-scrollable-container': '8px',
    'fwc-progress': '4px',
    'fwc-select-options-container': '4px',
    'fwc-tag': '999999px',
    'fwc-tag-badge': '999999px',
    'temp-do-not-use-300': '8px',
    'temp-future-300': '8px',
    'transitional-component': '4px',
    'transitional-container': '8px',
    'transitional-container-alt': '8px',
    'transitional-floating': '16px',
    'transitional-full-0': '999999px',
    'transitional-full-3': '999999px',
    'transitional-full-8': '999999px'
  },
  fontSize: {
    'fwc-table-header-font-size': '12px'
  },
  fontWeight: {
    'fwc-table-header-font-weight': '500'
  },
  borderWidth: {
    '0': '0px',
    '100': '1px',
    '200': '2px',
    '300': '4px',
    'fwc-alert-100': '0px',
    'fwc-table-header-divider-width-default': '1px',
    'transitional-1': '1px',
    'transitional-2': '1px'
  },
  boxShadow: {
    '100': '0px 1px 8px 0px rgba(20,20,20,0.08)',
    '200': '0px 8px 16px 0px rgba(20,20,20,0.04)',
    '300': '0px 16px 32px 0px rgba(20,20,20,0.08)',
    '400': '0px 24px 48px 0px rgba(20,20,20,0.08)'
  },
  color: {
    'border-accent-blue-default': '#016DE1',
    'border-accent-green-default': '#00823A',
    'border-accent-light-orange-default': '#C93700',
    'border-accent-magenta-default': '#D20688',
    'border-accent-orange-default': '#C93700',
    'border-accent-purple-default': '#7D53E9',
    'border-accent-red-default': '#D9002B',
    'border-accent-yellow-default': '#956309',
    'border-alert-default': '#D9002B',
    'border-brand-default': '#FF4800',
    'border-caution-default': '#EEB117',
    'border-container-default': '#CCCCCC',
    'border-core-default': '#8A8A8A',
    'border-core-disabled': '#E6E6E6',
    'border-core-hover': '#666666',
    'border-core-on-fill-default': '#FFFFFF',
    'border-core-pressed': '#141414',
    'border-core-subtle': '#CCCCCC',
    'border-core-subtle-hover': '#B3B3B3',
    'border-core-subtle-pressed': '#8A8A8A',
    'border-info-default': '#016DE1',
    'border-interactive-default': '#8A8A8A',
    'border-interactive-pressed': '#141414',
    'border-inverse-default': '#141414',
    'border-inverse-default-alt': 'rgba(20,20,20,0)',
    'border-inverse-disabled': '#E6E6E6',
    'border-inverse-disabled-alt': 'rgba(20,20,20,0)',
    'border-positive-default': '#00823A',
    'border-primary-default': 'rgba(20,20,20,0)',
    'border-primary-disabled': 'rgba(20,20,20,0)',
    'border-primary-on-fill': '#BCFF2B',
    'border-primary-on-fill-default': '#BCFF2B',
    'border-primary-subtle': '#BCFF2B',
    'border-primary-subtle-default': '#BCFF2B',
    'border-primary-subtle-hover': '#BCFF2B',
    'border-primary-subtle-pressed': '#BCFF2B',
    'border-secondary-default': '#8A8A8A',
    'border-secondary-default-alt': '#8A8A8A',
    'border-secondary-disabled': '#E6E6E6',
    'border-secondary-disabled-alt': '#E6E6E6',
    'border-surface-default': '#BCFF2B',
    'border-tertiary-default': '#8A8A8A',
    'border-tertiary-disabled': '#E6E6E6',
    'border-transitional-core-subtle': '#CCCCCC',
    'border-transitional-core-subtle-alt': '#CCCCCC',
    'border-transitional-interactive-subtle': '#CCCCCC',
    'border-transitional-primary-alt': '#141414',
    'border-transitional-tertiary-default': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-border-badge-default': 'linear-gradient(135deg, #FF3842 0%, #D20688 100%)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-border-field-default': '#D20688',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-border-secondary-default': '#D20688',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-border-secondary-disabled': '#E6E6E6',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-border-secondary-hover': '#A5016A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-border-secondary-pressed': '#800051',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-border-tertiary-default': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-border-tertiary-disabled': '#E6E6E6',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-border-tertiary-hover': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-border-tertiary-pressed': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-badge-default': 'rgba(20,20,20,0)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-component-disabled': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-feedback-active': '#141414',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-feedback-default': 'rgba(20,20,20,0)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-feedback-hover': 'rgba(20,20,20,0.08)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-loading-dot-default': '#FF9FCC',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-primary-default': '#D20688',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-primary-disabled': '#F5F5F5',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-primary-hover': '#A5016A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-primary-pressed': '#800051',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-secondary-default': 'rgba(20,20,20,0)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-secondary-disabled': '#F5F5F5',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-secondary-hover': '#FCEBF2',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-secondary-pressed': '#FBDBE9',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-shimmer-default': 'linear-gradient(135deg, #FBDDD2 0%, #FBDBE9 100%)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-special-btn-alt-default': 'linear-gradient(114deg, #FF3842 0%, #D20688 100%)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-special-btn-alt-disabled': '#FF3842',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-special-btn-default': 'linear-gradient(135deg, #FF3842 0%, #D20688 100%)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-special-btn-hover': 'linear-gradient(135deg, #D9002B 0%, #A5016A 100%)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-special-btn-pressed': 'linear-gradient(135deg, #AC0020 0%, #800051 100%)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-tertiary-default': 'rgba(20,20,20,0)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-tertiary-disabled': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-tertiary-hover': 'rgba(20,20,20,0.08)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-tertiary-pressed': 'rgba(20,20,20,0.11)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-fill-transparent-defauilt': 'rgba(20,20,20,0)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-component-disabled': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-feedback-active': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-feedback-default': '#141414',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-field-default': '#D20688',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-field-disabled': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-full-page-loader-default': 'linear-gradient(135deg, #FB31A7 0%, #FF4800 23%, #FBDDD2 100%)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-icon-button-default': '#141414',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-icon-button-hover': '#A5016A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-icon-button-pressed': '#800051',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-primary-default': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-primary-disabled': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-secondary-default': '#D20688',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-special-btn-default': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-tertiary-default': '#141414',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-icon-transparent-default': '#D20688',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-badge-default': '#D20688',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-component-disabled': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-field-default': '#666666',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-field-disabled': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-field-input': '#141414',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-primary-default': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-primary-disabled': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-secondary-default': '#D20688',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-secondary-disabled': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-secondary-hover': '#A5016A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-secondary-pressed': '#800051',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-special-btn-default': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-tertiary-default': '#141414',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-tertiary-disabled': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-transparent-default': '#D20688',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-transparent-hover': '#A5016A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'breeze-text-transparent-pressed': '#800051',
    'do-not-use-alert-danger': '#D9002B',
    'do-not-use-alert-success': '#00641A',
    'do-not-use-alert-warning': '#EEB117',
    'do-not-use-battleship': '#B6B1AF',
    'do-not-use-button-danger-hover-fill': '#AC0020',
    'do-not-use-button-disabled-text': '#b0c1d4',
    'do-not-use-button-primary-hover-fill': '#6431DA',
    'do-not-use-button-secondary-active-fill': '#4D4C4C',
    'do-not-use-button-secondary-hover-fill': '#333333',
    'do-not-use-button-secondary-text': '#FFFFFF',
    'do-not-use-button-tertiary-light-hover-fill': '#CFCCCB',
    'do-not-use-button-tertiary-light-text': '#1F1F1F',
    'do-not-use-calypso': '#016DE1',
    'do-not-use-calypso-dark': '#0035B2',
    'do-not-use-calypso-light': '#D0E8F5',
    'do-not-use-calypso-medium': '#0050C7',
    'do-not-use-candy-apple': '#D9002B',
    'do-not-use-candy-apple-dark': '#850016',
    'do-not-use-candy-apple-light': '#FBDDD8',
    'do-not-use-candy-apple-medium': '#AC0020',
    'do-not-use-chart-aqua': '#51d3d9',
    'do-not-use-chart-blue': '#81c1fd',
    'do-not-use-chart-dark-purple': '#9784c2',
    'do-not-use-chart-green': '#a2d28f',
    'do-not-use-chart-orange': '#fea58e',
    'do-not-use-chart-purple': '#bda9ea',
    'do-not-use-chart-red': '#ea90b1',
    'do-not-use-chart-yellow': '#f5c78e',
    'do-not-use-cirrus': '#f2f5f8',
    'do-not-use-eerie': '#676565',
    'do-not-use-facebook': '#3b5998',
    'do-not-use-flat-earth': '#253342',
    'do-not-use-flint': '#000000',
    'do-not-use-focus-ring-base': '#00d0e4',
    'do-not-use-google': '#dd4b39',
    'do-not-use-great-white': '#000000',
    'do-not-use-gypsum': '#FFFFFF',
    'do-not-use-heffalump': '#425B76',
    'do-not-use-instagram': '#c13584',
    'do-not-use-koala': '#E5E1FA',
    'do-not-use-link-hover': '#5113BA',
    'do-not-use-linkedin': '#0077b5',
    'do-not-use-lorax': '#5113BA',
    'do-not-use-lorax-dark': '#7D53E9',
    'do-not-use-lorax-light': '#333333',
    'do-not-use-lorax-medium': '#FF7D4C',
    'do-not-use-marigold': '#EEB117',
    'do-not-use-marigold-dark': '#B67E0E',
    'do-not-use-marigold-light': '#FBE0A5',
    'do-not-use-marigold-medium': '#D39913',
    'do-not-use-monolith': '#000000',
    'do-not-use-norman': '#D20688',
    'do-not-use-norman-dark': '#800051',
    'do-not-use-norman-light': '#FBDBE9',
    'do-not-use-norman-medium': '#A5016A',
    'do-not-use-obsidian': '#33475B',
    'do-not-use-olaf': '#FFFFFF',
    'do-not-use-oz': '#00641A',
    'do-not-use-oz-dark': '#03380C',
    'do-not-use-oz-light': '#B1F4AB',
    'do-not-use-oz-medium': '#004C12',
    'do-not-use-pantera': '#2d3e50',
    'do-not-use-pinterest': '#bd081c',
    'do-not-use-rss': '#f26522',
    'do-not-use-slinky': '#516F90',
    'do-not-use-sorbet': '#FF8F59',
    'do-not-use-sorbet-dark': '#E68250',
    'do-not-use-sorbet-light': '#FFF3EE',
    'do-not-use-sorbet-medium': '#FFC7AC',
    'do-not-use-thunderdome': '#5113BA',
    'do-not-use-thunderdome-dark': '#7D53E9',
    'do-not-use-thunderdome-light': '#E5E1FA',
    'do-not-use-thunderdome-medium': '#6431DA',
    'do-not-use-transparent': 'rgba(0, 0, 0, 0)',
    'do-not-use-transparent-dark': 'rgba(0, 0, 0, 0)',
    'do-not-use-transparent-light': 'rgba(0,0,0,0)',
    'do-not-use-twitter': '#55acee',
    'do-not-use-x': '#000000',
    'do-not-use-xing': '#026466',
    'do-not-use-youtube': '#ff0000',
    'fill-accent-blue-default': '#016DE1',
    'fill-accent-blue-hover': '#0050C7',
    'fill-accent-blue-pressed': '#0035B2',
    'fill-accent-blue-subtle': '#ACDAF4',
    'fill-accent-blue-subtle-alt': '#E1F2FB',
    'fill-accent-green-default': '#00823A',
    'fill-accent-green-hover': '#006831',
    'fill-accent-green-pressed': '#003C1E',
    'fill-accent-green-subtle': '#BDE7CB',
    'fill-accent-green-subtle-alt': '#EDF4EF',
    'fill-accent-light-orange-default': '#FF4800',
    'fill-accent-light-orange-hover': '#C93700',
    'fill-accent-light-orange-pressed': '#9F2800',
    'fill-accent-light-orange-subtle': '#FCC6B1',
    'fill-accent-light-orange-subtle-alt': '#FCECE6',
    'fill-accent-magenta-default': '#D20688',
    'fill-accent-magenta-hover': '#A5016A',
    'fill-accent-magenta-pressed': '#800051',
    'fill-accent-magenta-subtle': '#FCC3DC',
    'fill-accent-magenta-subtle-alt': '#FCEBF2',
    'fill-accent-neutral-default': '#141414',
    'fill-accent-neutral-hover': '#4D4D4D',
    'fill-accent-neutral-pressed': '#666666',
    'fill-accent-neutral-subtle': '#E6E6E6',
    'fill-accent-neutral-subtle-alt': '#F0F0F0',
    'fill-accent-orange-default': '#C93700',
    'fill-accent-orange-hover': '#9F2800',
    'fill-accent-orange-pressed': '#7B1D00',
    'fill-accent-orange-subtle': '#FCC6B1',
    'fill-accent-orange-subtle-alt': '#FCECE6',
    'fill-accent-purple-default': '#6431DA',
    'fill-accent-purple-hover': '#5113BA',
    'fill-accent-purple-pressed': '#321986',
    'fill-accent-purple-subtle': '#D7CDFC',
    'fill-accent-purple-subtle-alt': '#EFEEFD',
    'fill-accent-red-default': '#D9002B',
    'fill-accent-red-hover': '#AC0020',
    'fill-accent-red-pressed': '#850016',
    'fill-accent-red-subtle': '#FCC5BE',
    'fill-accent-red-subtle-alt': '#FCECE9',
    'fill-accent-teal-default': '#007C7D',
    'fill-accent-teal-hover': '#006162',
    'fill-accent-teal-pressed': '#00494B',
    'fill-accent-teal-subtle': '#B3F0ED',
    'fill-accent-teal-subtle-alt': '#E0FCFA',
    'fill-accent-yellow-default': '#956309',
    'fill-accent-yellow-hover': '#784B05',
    'fill-accent-yellow-pressed': '#5E3804',
    'fill-accent-yellow-subtle': '#FBE0A5',
    'fill-accent-yellow-subtle-alt': '#FCF6E6',
    'fill-alert-default': '#D9002B',
    'fill-alert-hover': '#AC0020',
    'fill-alert-pressed': '#850016',
    'fill-alert-subtle': '#FCECE9',
    'fill-brand-default': '#FF4800',
    'fill-brand-hover': '#C93700',
    'fill-brand-pressed': '#9F2800',
    'fill-brand-subtle': '#FCC6B1',
    'fill-caution-alt': '#BCFF2B',
    'fill-caution-default': '#FCCB57',
    'fill-caution-hover': '#EEB117',
    'fill-caution-pressed': '#D39913',
    'fill-caution-subtle': '#FCF6E6',
    'fill-field-default': '#FFFFFF',
    'fill-field-default-alt': '#FFFFFF',
    'fill-field-disabled': '#F5F5F5',
    'fill-field-hover': '#EBEBEB',
    'fill-field-pressed': '#E6E6E6',
    'fill-info-default': '#016DE1',
    'fill-info-hover': '#0050C7',
    'fill-info-pressed': '#0035B2',
    'fill-info-subtle': '#E1F2FB',
    'fill-inverse-danger': '#FFFFFF',
    'fill-inverse-default': '#FFFFFF',
    'fill-inverse-default-alt': '#141414',
    'fill-inverse-default-transparent': 'rgba(20,20,20,0)',
    'fill-inverse-disabled': '#FFFFFF',
    'fill-inverse-disabled-alt': '#F0F0F0',
    'fill-inverse-disabled-transparent': 'rgba(20,20,20,0)',
    'fill-inverse-hover': '#F0F0F0',
    'fill-inverse-hover-alt': '#333333',
    'fill-inverse-hover-transparent': 'rgba(20,20,20,0.08)',
    'fill-inverse-pressed': '#E6E6E6',
    'fill-inverse-pressed-alt': '#4D4D4D',
    'fill-inverse-pressed-transparent': 'rgba(20,20,20,0.11)',
    'fill-inverse-primary': '#FFFFFF',
    'fill-inverse-subtle': '#FFFFFF',
    'fill-positive-alt': '#BCFF2B',
    'fill-positive-default': '#00823A',
    'fill-positive-hover': '#006831',
    'fill-positive-pressed': '#005027',
    'fill-positive-subtle': '#EDF4EF',
    'fill-primary-default': '#141414',
    'fill-primary-disabled': '#F5F5F5',
    'fill-primary-hover': '#333333',
    'fill-primary-pressed': '#4D4D4D',
    'fill-primary-subtle': '#BCFF2B',
    'fill-secondary-default': '#FFFFFF',
    'fill-secondary-default-alt': '#D6C2D9',
    'fill-secondary-disabled': '#FFFFFF',
    'fill-secondary-disabled-alt': '#F5F5F5',
    'fill-secondary-hover': '#F0F0F0',
    'fill-secondary-hover-alt': '#CAAACF',
    'fill-secondary-pressed': '#E6E6E6',
    'fill-secondary-pressed-alt': '#BC8DC3',
    'fill-secondary-subtle': '#BCFF2B',
    'fill-surface-default': '#FFFFFF',
    'fill-surface-default-hover': 'rgba(20,20,20,0.08)',
    'fill-surface-default-pressed': 'rgba(20,20,20,0.11)',
    'fill-surface-overlay': '#BCFF2B',
    'fill-surface-raised': '#FFFFFF',
    'fill-surface-recessed': '#F0F0F0',
    'fill-surface-recessed-hover': 'rgba(20,20,20,0.08)',
    'fill-surface-recessed-pressed': 'rgba(20,20,20,0.11)',
    'fill-tertiary-alt': '#BCFF2B',
    'fill-tertiary-default': '#FFFFFF',
    'fill-tertiary-disabled': '#F5F5F5',
    'fill-tertiary-hover': '#EBEBEB',
    'fill-tertiary-pressed': '#E6E6E6',
    'fill-tertiary-subtle': '#BCFF2B',
    'fill-transitional-alert': '#D9002B',
    'fill-transitional-banner-gradient-color-1': '#D7CDFC',
    'fill-transitional-banner-gradient-color-2': '#D7CDFC',
    'fill-transitional-beta-button-gradient-color-1': '#D7CDFC',
    'fill-transitional-beta-button-gradient-color-2': '#D7CDFC',
    'fill-transitional-beta-button-hover': '#C4B4F7',
    'fill-transitional-danger-pattern-color-1': '#FFFFFF',
    'fill-transitional-danger-pattern-color-2': '#FFFFFF',
    'fill-transitional-field-hover': 'rgba(20,20,20,0.11)',
    'fill-transitional-modal-gradient-color-1': '#FFFFFF',
    'fill-transitional-modal-gradient-color-2': '#FFFFFF',
    'fill-transitional-popover': '#FFFFFF',
    'fill-transitional-progress-success-gradient-color-1': '#00823A',
    'fill-transitional-progress-success-gradient-color-2': '#00823A',
    'fill-transitional-progress-warning-danger-gradient-color-1': '#FCCB57',
    'fill-transitional-progress-warning-danger-gradient-color-2': '#FCCB57',
    'fill-transitional-scroll-default-gradient-color-1': '#F5F5F5',
    'fill-transitional-scroll-default-gradient-color-2': 'rgba(239,237,235,0)',
    'fill-transitional-scroll-fadeout-gradient-color-1': '#FFFFFF',
    'fill-transitional-scroll-fadeout-gradient-color-2': 'rgba(255,255,255,0)',
    'fill-transitional-shadow': 'rgba(20,20,20,0)',
    'fill-transitional-sidenav-on-recessed-active': 'rgba(204,204,204,0.4)',
    'fill-transitional-table-default': '#F0F0F0',
    'fill-transitional-tabs-default': '#FFFFFF',
    'fill-transitional-tabs-pressed': '#F5F5F5',
    'fill-transitional-tertiary-default': '#FFFFFF',
    'fill-transitional-tertiary-hover': '#F0F0F0',
    'fill-transitional-tertiary-pressed': '#E6E6E6',
    'fill-transitional-upgrade-modal-gradient-color-1': '#FFFFFF',
    'fill-transparent-default': 'rgba(20,20,20,0)',
    'fill-transparent-disabled': 'rgba(20,20,20,0)',
    'fill-transparent-hover': 'rgba(20,20,20,0)',
    'fill-transparent-pressed': 'rgba(20,20,20,0)',
    'fwc-alert-border-default': '#016DE1',
    'fwc-badge-border-beta': '#6431DA',
    'fwc-badge-border-blue': '#ACDAF4',
    'fwc-badge-border-calypso': '#016DE1',
    'fwc-badge-border-candy-apple': '#D9002B',
    'fwc-badge-border-free': '#C93700',
    'fwc-badge-border-green': '#BDE7CB',
    'fwc-badge-border-koala': '#F0F0F0',
    'fwc-badge-border-lorax': '#C93700',
    'fwc-badge-border-magenta': '#FCC3DC',
    'fwc-badge-border-marigold': '#FCCB57',
    'fwc-badge-border-new': '#00823A',
    'fwc-badge-border-norman': '#D20688',
    'fwc-badge-border-orange': '#FCC6B1',
    'fwc-badge-border-oz': '#00823A',
    'fwc-badge-border-pantera': '#141414',
    'fwc-badge-border-purple': '#D7CDFC',
    'fwc-badge-border-red': '#FCC5BE',
    'fwc-badge-border-sorbet': '#FF4800',
    'fwc-badge-border-teal': '#B3F0ED',
    'fwc-badge-border-teal-dark': '#007C7D',
    'fwc-badge-border-thunderdome': '#6431DA',
    'fwc-badge-border-yellow': '#FBE0A5',
    'fwc-badge-fill-beta': '#6431DA',
    'fwc-badge-fill-blue': '#ACDAF4',
    'fwc-badge-fill-calypso': '#016DE1',
    'fwc-badge-fill-candy-apple': '#D9002B',
    'fwc-badge-fill-free': '#C93700',
    'fwc-badge-fill-green': '#BDE7CB',
    'fwc-badge-fill-koala': '#F0F0F0',
    'fwc-badge-fill-lorax': '#C93700',
    'fwc-badge-fill-magenta': '#FCC3DC',
    'fwc-badge-fill-marigold': '#FCCB57',
    'fwc-badge-fill-new': '#00823A',
    'fwc-badge-fill-norman': '#D20688',
    'fwc-badge-fill-orange': '#FCC6B1',
    'fwc-badge-fill-oz': '#00823A',
    'fwc-badge-fill-pantera': '#141414',
    'fwc-badge-fill-purple': '#D7CDFC',
    'fwc-badge-fill-red': '#FCC5BE',
    'fwc-badge-fill-sorbet': '#FF4800',
    'fwc-badge-fill-teal': '#B3F0ED',
    'fwc-badge-fill-teal-dark': '#007C7D',
    'fwc-badge-fill-thunderdome': '#6431DA',
    'fwc-badge-fill-yellow': '#FBE0A5',
    'fwc-button-border-core-default': '#8A8A8A',
    'fwc-button-border-core-hover': '#666666',
    'fwc-button-border-core-on-fill-default': '#FFFFFF',
    'fwc-button-border-inverse-default': '#141414',
    'fwc-button-border-inverse-default-alt': 'rgba(20,20,20,0)',
    'fwc-button-border-inverse-disabled': '#E6E6E6',
    'fwc-button-border-inverse-disabled-alt': 'rgba(20,20,20,0)',
    'fwc-button-border-primary-default': 'rgba(20,20,20,0)',
    'fwc-button-border-primary-disabled': 'rgba(20,20,20,0)',
    'fwc-button-border-primary-hover': 'rgba(20,20,20,0)',
    'fwc-button-border-primary-pressed': 'rgba(20,20,20,0)',
    'fwc-button-border-secondary-default': '#8A8A8A',
    'fwc-button-border-secondary-default-alt': '#8A8A8A',
    'fwc-button-border-secondary-disabled': '#E6E6E6',
    'fwc-button-border-secondary-disabled-alt': '#E6E6E6',
    'fwc-button-border-tertiary-default': '#8A8A8A',
    'fwc-button-border-tertiary-disabled': '#E6E6E6',
    'fwc-button-border-transitional-tertiary-default': '#8A8A8A',
    'fwc-button-fill-alert-default': '#D9002B',
    'fwc-button-fill-alert-hover': '#AC0020',
    'fwc-button-fill-alert-pressed': '#850016',
    'fwc-button-fill-field-default-alt': '#FFFFFF',
    'fwc-button-fill-inverse-default': '#FFFFFF',
    'fwc-button-fill-inverse-default-alt': '#141414',
    'fwc-button-fill-inverse-disabled': '#FFFFFF',
    'fwc-button-fill-inverse-disabled-alt': '#F0F0F0',
    'fwc-button-fill-inverse-hover': '#F0F0F0',
    'fwc-button-fill-inverse-hover-alt': '#333333',
    'fwc-button-fill-inverse-pressed': '#E6E6E6',
    'fwc-button-fill-inverse-pressed-alt': '#4D4D4D',
    'fwc-button-fill-primary-default': '#141414',
    'fwc-button-fill-primary-disabled': '#F5F5F5',
    'fwc-button-fill-primary-hover': '#333333',
    'fwc-button-fill-primary-pressed': '#4D4D4D',
    'fwc-button-fill-secondary-default': '#FFFFFF',
    'fwc-button-fill-secondary-default-alt': '#D6C2D9',
    'fwc-button-fill-secondary-disabled': '#FFFFFF',
    'fwc-button-fill-secondary-disabled-alt': '#F5F5F5',
    'fwc-button-fill-secondary-hover': '#F0F0F0',
    'fwc-button-fill-secondary-hover-alt': '#CAAACF',
    'fwc-button-fill-secondary-pressed': '#E6E6E6',
    'fwc-button-fill-secondary-pressed-alt': '#BC8DC3',
    'fwc-button-fill-surface-default': '#FFFFFF',
    'fwc-button-fill-surface-raised': '#FFFFFF',
    'fwc-button-fill-tertiary-default': '#FFFFFF',
    'fwc-button-fill-tertiary-disabled': '#F5F5F5',
    'fwc-button-fill-tertiary-hover': '#EBEBEB',
    'fwc-button-fill-tertiary-pressed': '#E6E6E6',
    'fwc-button-fill-transitional-tertiary-default': '#FFFFFF',
    'fwc-button-fill-transitional-tertiary-hover': '#F0F0F0',
    'fwc-button-fill-transitional-tertiary-pressed': '#E6E6E6',
    'fwc-button-fill-transparent-default': 'rgba(20,20,20,0)',
    'fwc-button-specialty-link-on-fill-alt-default': '#006162',
    'fwc-button-specialty-link-on-fill-alt-pressed': '#033637',
    'fwc-button-specialty-link-on-fill-default': '#FFFFFF',
    'fwc-button-specialty-link-on-fill-disabled': '#B3B3B3',
    'fwc-button-specialty-link-on-fill-hover': '#F0F0F0',
    'fwc-button-specialty-link-on-fill-pressed': '#FFFFFF',
    'fwc-button-specialty-primary-on-fill-default': '#FFFFFF',
    'fwc-button-specialty-primary-on-fill-disabled': '#F5F5F5',
    'fwc-button-specialty-primary-on-fill-hover': '#E6E6E6',
    'fwc-button-specialty-primary-on-fill-pressed': '#CCCCCC',
    'fwc-button-specialty-tertiary-on-fill-default': '#333333',
    'fwc-button-specialty-tertiary-on-fill-disabled': '#333333',
    'fwc-button-specialty-tertiary-on-fill-hover': '#4D4D4D',
    'fwc-button-specialty-tertiary-on-fill-pressed': '#666666',
    'fwc-button-specialty-secondary-toolbar-default': '#D6C2D9',
    'fwc-button-specialty-secondary-toolbar-disabled': '#F5F5F5',
    'fwc-button-specialty-secondary-toolbar-hover': '#CAAACF',
    'fwc-button-specialty-secondary-toolbar-pressed': '#BC8DC3',
    'fwc-button-border-secondary-toolbar-default': '#8A8A8A',
    'fwc-button-border-secondary-toolbar-disabled': '#E6E6E6',
    'fwc-button-text-secondary-toolbar-default': '#141414',
    'fwc-button-text-secondary-toolbar-disabled': '#8A8A8A',
    'fwc-button-specialty-tertiary-transparent-default': 'rgba(255,255,255,0)',
    'fwc-button-specialty-tertiary-transparent-disabled': 'rgba(255,255,255,0)',
    'fwc-button-specialty-tertiary-transparent-hover': '#EBEBEB',
    'fwc-button-specialty-tertiary-transparent-pressed': '#E6E6E6',
    'fwc-button-specialty-text-core-alt-default': '#006162',
    'fwc-button-specialty-text-interactive-alt-default': '#141414',
    'fwc-button-specialty-text-interactive-alt-hover': '#4D4D4D',
    'fwc-button-specialty-text-interactive-alt-pressed': '#666666',
    'fwc-button-text-alert-default': '#D9002B',
    'fwc-button-text-alert-hover': '#AC0020',
    'fwc-button-text-alert-on-fill-default': '#FFFFFF',
    'fwc-button-text-alert-pressed': '#850016',
    'fwc-button-text-core-default': '#141414',
    'fwc-button-text-core-disabled': '#8A8A8A',
    'fwc-button-text-interactive-default': '#006162',
    'fwc-button-text-interactive-default-disabled': '#8A8A8A',
    'fwc-button-text-interactive-default-hover': '#00494B',
    'fwc-button-text-interactive-default-pressed': '#033637',
    'fwc-button-text-inverse-default': '#141414',
    'fwc-button-text-inverse-default-alt': '#FFFFFF',
    'fwc-button-text-inverse-disabled': '#8A8A8A',
    'fwc-button-text-inverse-disabled-alt': '#8A8A8A',
    'fwc-button-text-inverse-hover': '#4D4D4D',
    'fwc-button-text-inverse-pressed': '#666666',
    'fwc-button-text-primary-default': '#FFFFFF',
    'fwc-button-text-primary-disabled': '#8A8A8A',
    'fwc-button-text-secondary-default': '#141414',
    'fwc-button-text-secondary-disabled': '#8A8A8A',
    'fwc-button-text-tertiary-default': '#141414',
    'fwc-button-text-tertiary-disabled': '#8A8A8A',
    'fwc-link-icon-alert-default': '#D9002B',
    'fwc-link-icon-core-default': '#141414',
    'fwc-link-icon-interactive-default': '#141414',
    'fwc-link-icon-interactive-on-fill-default': '#FFFFFF',
    'fwc-link-specialty-link-on-fill-alt-default': '#006162',
    'fwc-link-specialty-link-on-fill-alt-disabled': '#8A8A8A',
    'fwc-link-specialty-link-on-fill-alt-hover': '#00494B',
    'fwc-link-specialty-link-on-fill-alt-pressed': '#033637',
    'fwc-link-specialty-link-on-fill-default': '#FFFFFF',
    'fwc-link-specialty-link-on-fill-disabled': '#B3B3B3',
    'fwc-link-specialty-link-on-fill-hover': '#F0F0F0',
    'fwc-link-specialty-link-on-fill-pressed': '#FFFFFF',
    'fwc-link-specialty-text-core-alt-default': '#006162',
    'fwc-link-specialty-text-interactive-alt-default': '#141414',
    'fwc-link-specialty-text-interactive-alt-hover': '#4D4D4D',
    'fwc-link-specialty-text-interactive-alt-pressed': '#666666',
    'fwc-link-text-alert-default': '#D9002B',
    'fwc-link-text-alert-hover': '#AC0020',
    'fwc-link-text-alert-pressed': '#850016',
    'fwc-link-text-core-default': '#141414',
    'fwc-link-text-core-disabled': '#8A8A8A',
    'fwc-link-text-interactive-default': '#006162',
    'fwc-link-text-interactive-default-disabled': '#8A8A8A',
    'fwc-link-text-interactive-default-hover': '#00494B',
    'fwc-link-text-interactive-default-pressed': '#033637',
    'fwc-link-underline-default': '#006162',
    'fwc-link-underline-disabled': '#8A8A8A',
    'fwc-link-underline-hover': '#00494B',
    'fwc-link-underline-inherit-idle': 'currentColor',
    'fwc-link-underline-pressed': '#033637',
    'fwc-loadingspinner-indicator-danger': '#D9002B',
    'fwc-loadingspinner-indicator-ghost': '#141414',
    'fwc-loadingspinner-indicator-link': '#141414',
    'fwc-loadingspinner-indicator-onfill': '#141414',
    'fwc-loadingspinner-indicator-primary': '#141414',
    'fwc-loadingspinner-indicator-success': '#00823A',
    'fwc-loadingspinner-indicator-tertiary': '#141414',
    'fwc-loadingspinner-ring-danger': '#E7E5E4',
    'fwc-loadingspinner-ring-ghost': '#141414',
    'fwc-loadingspinner-ring-link': '#E7E5E4',
    'fwc-loadingspinner-ring-onfill': '#F0F0F0',
    'fwc-loadingspinner-ring-primary': '#E7E5E4',
    'fwc-loadingspinner-ring-success': '#E6E6E6',
    'fwc-loadingspinner-ring-tertiary': '#F0F0F0',
    'fwc-progress-fill-alert-default': '#D9002B',
    'fwc-progress-fill-empty': '#F0F0F0',
    'fwc-progress-text-default': '#141414',
    'fwc-radio-border-default': '#8A8A8A',
    'fwc-radio-border-readonly': '#8A8A8A',
    'fwc-radio-fill-readonly-indicator': '#666666',
    'fwc-radio-text-readonly': '#666666',
    'fwc-ribbon-fill-beta': '#6431DA',
    'fwc-ribbon-fill-calypso': '#016DE1',
    'fwc-ribbon-fill-candy-apple': '#D9002B',
    'fwc-ribbon-fill-free': '#C93700',
    'fwc-ribbon-fill-heffalump': '#141414',
    'fwc-ribbon-fill-koala': '#FFFFFF',
    'fwc-ribbon-fill-lorax': '#C93700',
    'fwc-ribbon-fill-marigold': '#FCCB57',
    'fwc-ribbon-fill-new': '#00823A',
    'fwc-ribbon-fill-norman': '#D20688',
    'fwc-ribbon-fill-olaf': '#666666',
    'fwc-ribbon-fill-oz': '#00823A',
    'fwc-ribbon-fill-pantera': '#141414',
    'fwc-ribbon-fill-sorbet': '#FF4800',
    'fwc-ribbon-fill-thunderdome': '#7D53E9',
    'fwc-searchinput-border-default': '#8A8A8A',
    'fwc-selectable-border-default': '#8A8A8A',
    'fwc-selectable-border-selected': '#141414',
    'fwc-table-border-color-default': '#CCCCCC',
    'fwc-table-header-divider-color-default': '#CCCCCC',
    'fwc-table-header-text-default': '#141414',
    'fwc-table-header-top-border-color-default': '#CCCCCC',
    'fwc-table-divider-color-emphasis': '#CCCCCC',
    'fwc-tag-border-badge-blue': '#ACDAF4',
    'fwc-tag-border-badge-calypso': '#016DE1',
    'fwc-tag-border-badge-candy-apple': '#D9002B',
    'fwc-tag-border-badge-green': '#BDE7CB',
    'fwc-tag-border-badge-koala': '#F0F0F0',
    'fwc-tag-border-badge-lorax': '#C93700',
    'fwc-tag-border-badge-magenta': '#FCC3DC',
    'fwc-tag-border-badge-marigold': '#FCCB57',
    'fwc-tag-border-badge-norman': '#D20688',
    'fwc-tag-border-badge-orange': '#FCC6B1',
    'fwc-tag-border-badge-oz': '#00823A',
    'fwc-tag-border-badge-pantera': '#141414',
    'fwc-tag-border-badge-purple': '#D7CDFC',
    'fwc-tag-border-badge-red': '#FCC5BE',
    'fwc-tag-border-badge-sorbet': '#FF4800',
    'fwc-tag-border-badge-teal': '#B3F0ED',
    'fwc-tag-border-badge-teal-dark': '#007C7D',
    'fwc-tag-border-badge-thunderdome': '#6431DA',
    'fwc-tag-border-badge-yellow': '#FBE0A5',
    'fwc-tag-border-blue': '#016DE1',
    'fwc-tag-border-calypso': '#016DE1',
    'fwc-tag-border-candy-apple': '#D9002B',
    'fwc-tag-border-default': '#666666',
    'fwc-tag-border-green': '#00823A',
    'fwc-tag-border-heffalump': '#141414',
    'fwc-tag-border-koala': '#FFFFFF',
    'fwc-tag-border-lorax': '#C93700',
    'fwc-tag-border-magenta': '#D20688',
    'fwc-tag-border-marigold': '#EEB117',
    'fwc-tag-border-norman': '#D20688',
    'fwc-tag-border-olaf': '#666666',
    'fwc-tag-border-orange': '#C93700',
    'fwc-tag-border-oz': '#00823A',
    'fwc-tag-border-pantera': '#141414',
    'fwc-tag-border-purple': '#7D53E9',
    'fwc-tag-border-red': '#D9002B',
    'fwc-tag-border-sorbet': '#FF4800',
    'fwc-tag-border-subtle': '#CCCCCC',
    'fwc-tag-border-teal': '#007C7D',
    'fwc-tag-border-teal-dark': '#007C7D',
    'fwc-tag-border-teal-light': '#007C7D',
    'fwc-tag-border-thunderdome': '#7D53E9',
    'fwc-tag-border-yellow': '#EEB117',
    'fwc-tag-fill-badge-blue': '#ACDAF4',
    'fwc-tag-fill-badge-calypso': '#016DE1',
    'fwc-tag-fill-badge-candy-apple': '#D9002B',
    'fwc-tag-fill-badge-green': '#BDE7CB',
    'fwc-tag-fill-badge-koala': '#F0F0F0',
    'fwc-tag-fill-badge-lorax': '#C93700',
    'fwc-tag-fill-badge-magenta': '#FCC3DC',
    'fwc-tag-fill-badge-marigold': '#FCCB57',
    'fwc-tag-fill-badge-norman': '#D20688',
    'fwc-tag-fill-badge-orange': '#FCC6B1',
    'fwc-tag-fill-badge-oz': '#00823A',
    'fwc-tag-fill-badge-pantera': '#141414',
    'fwc-tag-fill-badge-purple': '#D7CDFC',
    'fwc-tag-fill-badge-red': '#FCC5BE',
    'fwc-tag-fill-badge-sorbet': '#FF4800',
    'fwc-tag-fill-badge-teal': '#B3F0ED',
    'fwc-tag-fill-badge-teal-dark': '#007C7D',
    'fwc-tag-fill-badge-thunderdome': '#6431DA',
    'fwc-tag-fill-badge-yellow': '#FBE0A5',
    'fwc-tag-fill-blue': '#ACDAF4',
    'fwc-tag-fill-calypso': '#E1F2FB',
    'fwc-tag-fill-candy-apple': '#FCECE9',
    'fwc-tag-fill-default': '#FFFFFF',
    'fwc-tag-fill-green': '#BDE7CB',
    'fwc-tag-fill-heffalump': '#FFFFFF',
    'fwc-tag-fill-koala': '#F0F0F0',
    'fwc-tag-fill-lorax': '#FCECE6',
    'fwc-tag-fill-magenta': '#FCC3DC',
    'fwc-tag-fill-marigold': '#FCF6E6',
    'fwc-tag-fill-norman': '#FCEBF2',
    'fwc-tag-fill-olaf': '#666666',
    'fwc-tag-fill-orange': '#FCC6B1',
    'fwc-tag-fill-oz': '#EDF4EF',
    'fwc-tag-fill-pantera': '#F0F0F0',
    'fwc-tag-fill-purple': '#D7CDFC',
    'fwc-tag-fill-red': '#FCC5BE',
    'fwc-tag-fill-sorbet': '#FCECE6',
    'fwc-tag-fill-subtle': '#FFFFFF',
    'fwc-tag-fill-teal': '#B3F0ED',
    'fwc-tag-fill-teal-dark': '#E0FCFA',
    'fwc-tag-fill-teal-light': '#E0FCFA',
    'fwc-tag-fill-thunderdome': '#EFEEFD',
    'fwc-tag-fill-yellow': '#FBE0A5',
    'fwc-tag-text-marigold': '#141414',
    'fwc-tag-text-onfill': '#141414',
    'fwc-tag-text-subtle': '#666666',
    'fwc-textinput-border-readonly': '#E6E6E6',
    'fwc-textinput-fill-readonly': '#F5F5F5',
    'fwc-toggle-border-readonly': '#E6E6E6',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-border-dark': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-border-default': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-border-search-btn-border-default': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-border-search-btn-border-hover': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-border-search-field-border-default': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-border-subtle': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-editortitle-hover': 'rgba(20,20,20,0.11)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-logo-default': '#FF4800',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-nav-item-default': '#333333',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-nav-item-hover': '#4D4D4D',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-nav-item-selected': '#666666',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-search-default': '#333333',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-search-hover': '#666666',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-sub-nav-item-default': '#333333',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-sub-nav-item-hover': '#4D4D4D',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-sub-nav-item-selected': '#666666',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-surface-default': '#333333',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-fill-surface-panel-default': '#333333',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-icon-bookmark-default': 'rgba(255,255,255,0)',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-icon-bookmark-hover': '#F0F0F0',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-icon-bookmark-selected': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-icon-copilot-default': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-icon-nav-item-default': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-icon-nav-item-hover': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-icon-nav-item-selected': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-icon-nav-item-subtle': '#B3B3B3',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-text-copilot-default': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-text-copilot-hover': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-text-nav-item-default': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-text-nav-item-default-subtle': '#B3B3B3',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-text-nav-item-hover': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-text-nav-item-hover-subtle': '#B3B3B3',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-text-nav-item-selected': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'global-shell-text-nav-item-selected-subtle': '#B3B3B3',
    'icon-accent-blue-default': '#BCFF2B',
    'icon-accent-blue-on-fill-default': '#BCFF2B',
    'icon-accent-blue-on-fill-subtle': '#BCFF2B',
    'icon-accent-green-default': '#BCFF2B',
    'icon-accent-green-on-fill-default': '#BCFF2B',
    'icon-accent-green-on-fill-subtle': '#BCFF2B',
    'icon-accent-magenta-default': '#BCFF2B',
    'icon-accent-magenta-on-fill-default': '#BCFF2B',
    'icon-accent-magenta-on-fill-subtle': '#BCFF2B',
    'icon-accent-orange-default': '#BCFF2B',
    'icon-accent-orange-on-fill-default': '#BCFF2B',
    'icon-accent-orange-on-fill-subtle': '#BCFF2B',
    'icon-accent-purple-default': '#BCFF2B',
    'icon-accent-purple-on-fill-default': '#BCFF2B',
    'icon-accent-purple-on-fill-subtle': '#BCFF2B',
    'icon-accent-red-default': '#BCFF2B',
    'icon-accent-red-on-fill-default': '#BCFF2B',
    'icon-accent-red-on-fill-subtle': '#BCFF2B',
    'icon-accent-teal-default': '#BCFF2B',
    'icon-accent-teal-on-fill-default': '#BCFF2B',
    'icon-accent-teal-on-fill-subtle': '#BCFF2B',
    'icon-accent-yellow-default': '#BCFF2B',
    'icon-accent-yellow-on-fill-default': '#BCFF2B',
    'icon-accent-yellow-on-fill-subtle': '#BCFF2B',
    'icon-alert-default': '#D9002B',
    'icon-alert-hover': '#AC0020',
    'icon-alert-on-fill-default': '#FFFFFF',
    'icon-alert-on-fill-subtle': '#BCFF2B',
    'icon-alert-pressed': '#850016',
    'icon-brand-default': '#BCFF2B',
    'icon-brand-on-fill-default': '#BCFF2B',
    'icon-brand-on-fill-subtle': '#BCFF2B',
    'icon-caution-default': '#BCFF2B',
    'icon-caution-on-fill-alt': '#BCFF2B',
    'icon-caution-on-fill-default': '#BCFF2B',
    'icon-caution-on-fill-subtle': '#BCFF2B',
    'icon-core-default': '#141414',
    'icon-core-disabled': '#8A8A8A',
    'icon-core-on-fill-default': '#FFFFFF',
    'icon-core-subtle': '#666666',
    'icon-info-default': '#BCFF2B',
    'icon-info-on-fill-default': '#BCFF2B',
    'icon-info-on-fill-subtle': '#BCFF2B',
    'icon-interactive-default': '#141414',
    'icon-interactive-disabled': '#8A8A8A',
    'icon-interactive-hover': '#4D4D4D',
    'icon-interactive-on-fill-default': '#FFFFFF',
    'icon-interactive-on-fill-hover': '#E6E6E6',
    'icon-interactive-on-fill-pressed': '#B3B3B3',
    'icon-interactive-on-fill-subtle': '#BCFF2B',
    'icon-interactive-pressed': '#666666',
    'icon-inverse-default': '#141414',
    'icon-inverse-default-alt': '#FFFFFF',
    'icon-inverse-disabled': '#8A8A8A',
    'icon-inverse-disabled-alt': '#8A8A8A',
    'icon-inverse-hover': '#4D4D4D',
    'icon-inverse-pressed': '#666666',
    'icon-positive-default': '#BCFF2B',
    'icon-positive-on-fill-alt': '#BCFF2B',
    'icon-positive-on-fill-default': '#BCFF2B',
    'icon-positive-on-fill-subtle': '#BCFF2B',
    'icon-primary-default': '#FFFFFF',
    'icon-primary-disabled': '#8A8A8A',
    'icon-primary-hover': '#FFFFFF',
    'icon-primary-on-fill-default': '#BCFF2B',
    'icon-primary-on-fill-subtle': '#BCFF2B',
    'icon-primary-pressed': '#FFFFFF',
    'icon-secondary-default': '#141414',
    'icon-secondary-disabled': '#8A8A8A',
    'icon-secondary-subtle': '#BCFF2B',
    'icon-tertiary-default': '#141414',
    'icon-tertiary-disabled': '#8A8A8A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-alert': '#FF3842',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-caution': '#FCCB57',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-default-dark-aqua': '#009B9C',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-default-dark-blue': '#078CFD',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-default-dark-green': '#119D49',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-default-dark-orange': '#FF7D4C',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-default-dark-pink': '#A5016A',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-default-dark-purple': '#9778EC',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-default-dark-yellow': '#B67E0E',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-default-light-aqua': '#48D1CF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-default-light-blue': '#8CC4F4',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-default-light-green': '#97DBAE',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-default-light-orange': '#FFA581',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-default-light-pink': '#FF9FCC',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-default-light-purple': '#C4B4F7',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-default-light-yellow': '#FBE0A5',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-positive': '#6ACB8C',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-scale-dark-aqua': '#006162',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-scale-dark-blue': '#0035B2',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-scale-dark-green': '#005027',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-scale-dark-orange': '#7B1D00',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-scale-dark-pink': '#800051',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-scale-dark-purple': '#321986',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-scale-dark-yellow': '#B67E0E',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-scale-light-aqua': '#B3F0ED',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-scale-light-blue': '#ACDAF4',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-scale-light-green': '#DAEFE1',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-scale-light-orange': '#FCF5F2',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-scale-light-pink': '#FCEBF2',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-scale-light-purple': '#F9F5FF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-scale-light-yellow': '#FCF6E6',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-chart-white': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-highlight-blue-default': '#ACDAF4',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-highlight-blue-subtle': '#E1F2FB',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-highlight-green-default': '#BDE7CB',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-highlight-green-subtle': '#EDF4EF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-highlight-orange-default': '#FCC6B1',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-highlight-orange-subtle': '#FCECE6',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-highlight-purple-default': '#D7CDFC',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-highlight-purple-subtle': '#EFEEFD',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-highlight-red-default': '#FCC5BE',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-highlight-red-subtle': '#FCECE9',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-highlight-yellow-default': '#FBE0A5',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'reporting-fill-highlight-yellow-subtle': '#FCF6E6',
    'specialty-filter-pressed': '#D9D9D9',
    'specialty-link-on-fill-alt-default': '#006162',
    'specialty-link-on-fill-alt-disabled': '#8A8A8A',
    'specialty-link-on-fill-alt-hover': '#00494B',
    'specialty-link-on-fill-alt-pressed': '#033637',
    'specialty-link-on-fill-default': '#FFFFFF',
    'specialty-link-on-fill-disabled': '#B3B3B3',
    'specialty-link-on-fill-hover': '#F0F0F0',
    'specialty-link-on-fill-pressed': '#FFFFFF',
    'specialty-notification': '#BCFF2B',
    'specialty-primary-on-fill-default': '#FFFFFF',
    'specialty-primary-on-fill-disabled': '#F5F5F5',
    'specialty-primary-on-fill-hover': '#E6E6E6',
    'specialty-primary-on-fill-pressed': '#CCCCCC',
    'specialty-scrim': 'rgba(20,20,20,0.46)',
    'specialty-scrim-alt': 'rgba(255,255,255,0.81)',
    'specialty-table-header-default': '#F0F0F0',
    'specialty-table-header-hover': '#EBEBEB',
    'specialty-table-header-pressed': '#E6E6E6',
    'specialty-table-zebra-stripe-default': '#F5F5F5',
    'specialty-tertiary-on-fill-default': '#333333',
    'specialty-tertiary-on-fill-disabled': '#333333',
    'specialty-tertiary-on-fill-hover': '#4D4D4D',
    'specialty-tertiary-on-fill-pressed': '#666666',
    'specialty-tertiary-transparent-default': 'rgba(255,255,255,0)',
    'specialty-tertiary-transparent-disabled': 'rgba(255,255,255,0)',
    'specialty-tertiary-transparent-hover': '#EBEBEB',
    'specialty-tertiary-transparent-pressed': '#E6E6E6',
    'specialty-text-core-alt-default': '#006162',
    'specialty-text-interactive-alt-default': '#141414',
    'specialty-text-interactive-alt-hover': '#4D4D4D',
    'specialty-text-interactive-alt-pressed': '#666666',
    'temp-do-not-use-border-primary-default': '#BCFF2B',
    'temp-do-not-use-border-primary-disabled': '#BCFF2B',
    'temp-do-not-use-fill-accent-teal-default': '#BCFF2B',
    'temp-do-not-use-fill-accent-teal-hover': '#BCFF2B',
    'temp-do-not-use-fill-accent-teal-pressed': '#BCFF2B',
    'temp-do-not-use-fill-accent-teal-subtle': '#BCFF2B',
    'temp-do-not-use-fill-field-hover': '#BCFF2B',
    'temp-do-not-use-fill-field-pressed': '#BCFF2B',
    'temp-do-not-use-fill-secondary-default': '#BCFF2B',
    'temp-do-not-use-fill-secondary-hover': '#BCFF2B',
    'temp-do-not-use-fill-secondary-pressed': '#BCFF2B',
    'temp-do-not-use-fill-surface-default-hover': '#BCFF2B',
    'temp-do-not-use-fill-surface-default-pressed': '#BCFF2B',
    'temp-do-not-use-fill-surface-recessed': '#BCFF2B',
    'temp-do-not-use-icon-primary-default': '#BCFF2B',
    'temp-do-not-use-icon-primary-hover': '#BCFF2B',
    'temp-do-not-use-icon-primary-pressed': '#BCFF2B',
    'temp-do-not-use-reporting-fill-highlight-purple-subtle': '#BCFF2B',
    'temp-do-not-use-specialty-scrim': '#BCFF2B',
    'temp-do-not-use-text-primary-default': '#BCFF2B',
    'temp-do-not-use-text-primary-subtle': '#BCFF2B',
    'temp-future-border-primary-default': 'rgba(20,20,20,0)',
    'temp-future-border-primary-disabled': 'rgba(20,20,20,0)',
    'temp-future-fill-accent-teal-default': '#007C7D',
    'temp-future-fill-accent-teal-hover': '#006162',
    'temp-future-fill-accent-teal-pressed': '#00494B',
    'temp-future-fill-accent-teal-subtle': '#B3F0ED',
    'temp-future-fill-field-hover': '#EFEDEB',
    'temp-future-fill-field-pressed': '#E7E5E4',
    'temp-future-fill-secondary-default': '#FFFFFF',
    'temp-future-fill-secondary-hover': '#F5F3F2',
    'temp-future-fill-secondary-pressed': '#E7E5E4',
    'temp-future-fill-surface-default-hover': 'rgba(20,20,20,0.08)',
    'temp-future-fill-surface-default-pressed': 'rgba(20,20,20,0.11)',
    'temp-future-fill-surface-recessed': '#F8F7F6',
    'temp-future-icon-primary-default': '#FFFFFF',
    'temp-future-icon-primary-hover': '#FFFFFF',
    'temp-future-icon-primary-pressed': '#FFFFFF',
    /** This token is not part of the public theme and should only be used by specialty packages. */
    'temp-future-reporting-fill-highlight-purple-subtle': '#EFEEFD',
    'temp-future-specialty-scrim': 'rgba(20,20,20,0.46)',
    'temp-future-text-primary-default': '#FFFFFF',
    'temp-future-text-primary-subtle': '#FFFFFF',
    'text-accent-blue-default': '#BCFF2B',
    'text-accent-blue-on-fill-default': '#BCFF2B',
    'text-accent-blue-on-fill-subtle': '#BCFF2B',
    'text-accent-green-default': '#BCFF2B',
    'text-accent-green-on-fill-default': '#BCFF2B',
    'text-accent-green-on-fill-subtle': '#BCFF2B',
    'text-accent-magenta-default': '#BCFF2B',
    'text-accent-magenta-on-fill-default': '#BCFF2B',
    'text-accent-magenta-on-fill-subtle': '#BCFF2B',
    'text-accent-purple-default': '#BCFF2B',
    'text-accent-purple-on-fill-default': '#BCFF2B',
    'text-accent-purple-on-fill-subtle': '#BCFF2B',
    'text-accent-red-default': '#BCFF2B',
    'text-accent-red-on-fill-default': '#BCFF2B',
    'text-accent-red-on-fill-subtle': '#BCFF2B',
    'text-accent-teal-default': '#BCFF2B',
    'text-accent-teal-on-fill-default': '#BCFF2B',
    'text-accent-teal-on-fill-subtle': '#BCFF2B',
    'text-accent-yellow-default': '#BCFF2B',
    'text-accent-yellow-on-fill-default': '#BCFF2B',
    'text-accent-yellow-on-fill-subtle': '#BCFF2B',
    'text-alert-default': '#D9002B',
    'text-alert-hover': '#AC0020',
    'text-alert-on-fill': '#BCFF2B',
    'text-alert-on-fill-default': '#FFFFFF',
    'text-alert-on-fill-subtle': '#BCFF2B',
    'text-alert-pressed': '#850016',
    'text-brand-default': '#9F2800',
    'text-brand-on-fill-default': '#BCFF2B',
    'text-brand-on-fill-subtle': '#BCFF2B',
    'text-caution-default': '#BCFF2B',
    'text-caution-on-fill-alt': '#BCFF2B',
    'text-caution-on-fill-default': '#BCFF2B',
    'text-caution-on-fill-subtle': '#BCFF2B',
    'text-core-default': '#141414',
    'text-core-disabled': '#8A8A8A',
    'text-core-on-fill-default': '#FFFFFF',
    'text-core-subtle': '#666666',
    'text-info-default': '#BCFF2B',
    'text-info-on-fill-default': '#BCFF2B',
    'text-info-on-fill-subtle': '#BCFF2B',
    'text-interactive-default': '#006162',
    'text-interactive-default-disabled': '#8A8A8A',
    'text-interactive-default-hover': '#00494B',
    'text-interactive-default-pressed': '#033637',
    'text-interactive-on-fill': '#FFFFFF',
    'text-interactive-on-fill-default': '#FFFFFF',
    'text-interactive-on-fill-hover': '#E6E6E6',
    'text-interactive-on-fill-pressed': '#B3B3B3',
    'text-interactive-on-fill-subtle': '#BCFF2B',
    'text-inverse-default': '#141414',
    'text-inverse-default-alt': '#FFFFFF',
    'text-inverse-disabled': '#8A8A8A',
    'text-inverse-disabled-alt': '#8A8A8A',
    'text-inverse-hover': '#4D4D4D',
    'text-inverse-pressed': '#666666',
    'text-positive-default': '#BCFF2B',
    'text-positive-on-fill-alt': '#BCFF2B',
    'text-positive-on-fill-default': '#BCFF2B',
    'text-positive-on-fill-subtle': '#BCFF2B',
    'text-primary-default': '#FFFFFF',
    'text-primary-disabled': '#8A8A8A',
    'text-primary-on-fill-default': '#BCFF2B',
    'text-primary-on-fill-subtle': '#BCFF2B',
    'text-primary-subtle': '#FFFFFF',
    'text-secondary-default': '#141414',
    'text-secondary-disabled': '#8A8A8A',
    'text-tertiary-default': '#141414',
    'text-tertiary-disabled': '#8A8A8A'
  },
  space: {
    '0': '0px',
    '25': '1px',
    '50': '2px',
    '100': '4px',
    '200': '8px',
    '250': '10px',
    '300': '12px',
    '400': '16px',
    '500': '20px',
    '600': '24px',
    '700': '28px',
    '800': '32px',
    '900': '36px',
    '1000': '40px',
    '1100': '48px',
    '1200': '56px',
    '1300': '60px',
    '1400': '64px',
    '1500': '96px',
    '1600': '144px',
    '1700': '192px'
  },
  typography: {
    'body-100': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '300',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'body-125': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '600',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'body-200': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '16px',
      fontWeight: '300',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'body-300': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '18px',
      fontWeight: '400',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'body-400': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '20px',
      fontWeight: '400',
      letterSpacing: '0px',
      lineHeight: '28px'
    },
    'body-500': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '22px',
      fontWeight: '400',
      letterSpacing: '0px',
      lineHeight: '28px'
    },
    'body-600': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '26px',
      fontWeight: '400',
      letterSpacing: '0px',
      lineHeight: '32px'
    },
    'body-700': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '28px',
      fontWeight: '400',
      letterSpacing: '0px',
      lineHeight: '36px'
    },
    'code-100': {
      fontFamily: 'Source Code Pro, Consolas, Monaco, Courier New, monospace',
      fontSize: '14px',
      fontWeight: '500',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'detail-100': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '12px',
      fontWeight: '300',
      letterSpacing: '0px',
      lineHeight: '14px'
    },
    'detail-200': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '12px',
      fontWeight: '300',
      letterSpacing: '0px',
      lineHeight: '18px'
    },
    'display-100': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '56px',
      fontWeight: '500',
      letterSpacing: '-0.32px',
      lineHeight: '72px'
    },
    'display-200': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '66px',
      fontWeight: '500',
      letterSpacing: '-0.32px',
      lineHeight: '76px'
    },
    'display-300': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '76px',
      fontWeight: '500',
      letterSpacing: '-0.32px',
      lineHeight: '88px'
    },
    'display-400': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '84px',
      fontWeight: '500',
      letterSpacing: '-0.32px',
      lineHeight: '96px'
    },
    'display-500': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '94px',
      fontWeight: '500',
      letterSpacing: '-0.32px',
      lineHeight: '100px'
    },
    'heading-100': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '16px',
      fontWeight: '600',
      letterSpacing: '0px',
      lineHeight: '20px'
    },
    'heading-1000': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '55px',
      fontWeight: '700',
      letterSpacing: '0px',
      lineHeight: '67px'
    },
    'heading-200': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '18px',
      fontWeight: '500',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'heading-25': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '12px',
      fontWeight: '600',
      letterSpacing: '0px',
      lineHeight: '18px'
    },
    'heading-300': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '20px',
      fontWeight: '600',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'heading-400': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '22px',
      fontWeight: '500',
      letterSpacing: '0px',
      lineHeight: '27px'
    },
    'heading-50': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '600',
      letterSpacing: '0px',
      lineHeight: '18px'
    },
    'heading-500': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '24px',
      fontWeight: '300',
      letterSpacing: '0px',
      lineHeight: '29px'
    },
    'heading-600': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '32px',
      fontWeight: '700',
      letterSpacing: '0px',
      lineHeight: '39px'
    },
    'heading-700': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '36px',
      fontWeight: '500',
      letterSpacing: '-0.16px',
      lineHeight: '44px'
    },
    'heading-800': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '42px',
      fontWeight: '500',
      letterSpacing: '-0.16px',
      lineHeight: '52px'
    },
    'heading-900': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '46px',
      fontWeight: '500',
      letterSpacing: '-0.16px',
      lineHeight: '56px'
    },
    link: {
      textUnderlineOffset: '24%'
    },
    'link-100': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '700',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'link-200': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '16px',
      fontWeight: '700',
      letterSpacing: '0px',
      lineHeight: '24px'
    },
    'link-25': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontSize: '12px',
      fontWeight: '700',
      letterSpacing: '0px',
      lineHeight: '18px'
    }
  }
};
Object.assign(theme, {
  [THEME_NAME]: 'trellis',
  [THEME_MODE]: 'light'
});
export default theme;